import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStaticPageList, saveContact } from "../Services/Apis";
import { toast } from "react-toastify";

export const getStaticPageListapi = createAsyncThunk("bannerlist/getStaticPageListapi", async () => {
    const res = await getStaticPageList();
    return res.data
});
export const saveContactapi = createAsyncThunk("saveContact", async (input_data) => {
    const res = await saveContact(input_data);
    return res.data
});

const globalslice = createSlice({
    name: "globalslice",
    initialState: {
        data: [],
        masterdata: [],
        loading: false,
        formmodal: false,
        formloading: false,
    },
    reducers: {
        setsidebar: (state) => {
            state.sidebarstatus = true; // Update hastoggle to true
        },
        setformmodal: (state, action) => {
            state.formmodal = action.payload;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getStaticPageListapi.pending, (state) => {
                state.loading = true
            })
            .addCase(getStaticPageListapi.fulfilled, (state, action) => {
                state.loading = false;
                state.masterdata = action.payload.data.searchResult;
            })
            .addCase(getStaticPageListapi.rejected, (state, action) => {
                state.loading = true;
                state.error = action.error.message;
            })
            .addCase(saveContactapi.pending, (state) => {
                state.formloading = true
            })
            .addCase(saveContactapi.fulfilled, (state, action) => {
                state.formmodal = false;
                state.formloading = false
                if (action.payload.success == true) {
                    state.formmodal = false;
                    toast.success(action.payload.message || "Contact saved successfully");
                } else {
                    toast.error(action.payload.message || "Failed to save contact");
                }
            })
            .addCase(saveContactapi.rejected, (state, action) => {
                state.formloading = true;
                state.error = action.error.message;
            })
    }
});
export const { setformmodal } = globalslice.actions
export default globalslice.reducer;
